import { render, staticRenderFns } from "./videoTable.vue?vue&type=template&id=5a90de53&scoped=true"
import script from "./videoTable.vue?vue&type=script&lang=js"
export * from "./videoTable.vue?vue&type=script&lang=js"
import style0 from "./videoTable.vue?vue&type=style&index=0&id=5a90de53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90de53",
  null
  
)

export default component.exports